// @core/api/endpoints/form/get_form_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  FormPolicyResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Get form policy
 * Returns a form policy by ID.
 */
export async function GetFormPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<FormPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/form-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<FormPolicyResponse>(requestPath, { ...requestOptions });
}
